import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../form/Button";
import { classNames } from "../../helpers/classNames";

const Modal = ({
  title,
  subtitle,
  children,
  isOpen = false,
  setIsOpen = () => {},
  size = "xl4",
  modalDialogueStyle = "",
}) => {
  const modalSize = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    xl2: "sm:max-w-2xl",
    xl3: "sm:max-w-3xl",
    xl4: "sm:max-w-4xl",
    xl5: "sm:max-w-5xl",
    xl6: "sm:max-w-6xl",
    xl7: "sm:max-w-7xl",
    xl8: "sm:max-w-8xl",
    xl9: "sm:max-w-9xl",
    full: "max-w-full",
  };

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-60"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gradient-to-b from-opplio-darkGray/80 via-opplio-darkGray/40 to-opplio-darkGray/80" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={`w-full ${modalSize[size]} transform text-left align-middle shadow-xl transition-all`}
                >
                  <div
                    className={classNames(
                      "rounded-2xl bg-white ",
                      modalDialogueStyle
                    )}
                  >
                    <div className="relative py-4 px-4 flex justify-between border-b border-indigo-900">
                      {(title || subtitle) && (
                        <div className="mr-auto flex-shrink">
                          {title && (
                            <h2 className="text-2xl tracking-tight font-semibold text-indigo-900">
                              {title}
                            </h2>
                          )}
                          {subtitle && (
                            <div className="text-sm font-medium text-opplio-grayW">
                              {subtitle}
                            </div>
                          )}
                        </div>
                      )}
                      <div className="ml-auto flex-shrink-0">
                        <Button
                          buttonIcon={"fa-regular fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonClasses={
                            "!w-8 !h-8 !p-0 !justify-center !text-xl !bg-indigo-900 !border-transparent !text-white hover:!bg-indigo-900 hover:rotate-90"
                          }
                          buttonFunction={() => setIsOpen(false)}
                        />
                      </div>
                    </div>
                    <div className="relative py-4 px-4">{children}</div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Modal;
